import _merge from 'lodash/merge';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { TRANSPARENT } from '../../../utils/colors';
import { makeDefaultStylingContext } from '../../../utils/style';
import { middle } from '../../../utils/sizes';
import {
  BORDER_RADIUS,
  STROKE_UNFOCUSED,
  STROKE_FOCUSED,
  STROKE_UNFOCUSED_COLOR,
  STROKE_FOCUSED_COLOR,
  FILL_UNFOCUSED_COLOR,
  FILL_FOCUSED_COLOR,
  TEXT_UNFOCUSED_COLOR,
  TEXT_FOCUSED_COLOR,
  SCALE_FOCUSED,
  FILL_SELECTED_COLOR,
  TEXT_SELECTED_COLOR,
} from './button.constants';
import { getStrokeWidth } from '../../../button/button.utils';
import { ButtonTexture } from '../../../callToAction/background/buttonTexture.component';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 72,
  [FULL_HD]: 96,
};

export const PADDING = {
  [HD]: 40,
  [FULL_HD]: 48,
};

export const ICON_WIDTH = {
  [HD]: 24,
  [FULL_HD]: 40,
};

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 40,
};

export const GAP = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const getUnFocusedStyle = ({ screenSize, colorMode, selected }) => ({
  Background: {
    borderWidth: getStrokeWidth(STROKE_UNFOCUSED[screenSize]),
    type: ButtonTexture,
    smooth: {
      color: selected ? FILL_SELECTED_COLOR[colorMode] : FILL_UNFOCUSED_COLOR[colorMode],
      borderColor: selected ? TRANSPARENT : STROKE_UNFOCUSED_COLOR[colorMode],
      scale: 1.0,
    },
  },
  IconLeft: {
    smooth: {
      color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_UNFOCUSED_COLOR[colorMode],
    },
  },
  IconRight: {
    smooth: {
      color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_UNFOCUSED_COLOR[colorMode],
    },
  },
  Label: {
    smooth: {
      color: selected ? TEXT_SELECTED_COLOR[colorMode] : TEXT_UNFOCUSED_COLOR[colorMode],
    },
  },
});

export const getFocusedStyle = ({ screenSize, colorMode }) => ({
  Background: {
    borderWidth: getStrokeWidth(STROKE_FOCUSED[screenSize]),
    smooth: {
      borderColor: STROKE_FOCUSED_COLOR[colorMode],
      color: FILL_FOCUSED_COLOR[colorMode],
      scale: SCALE_FOCUSED,
    },
  },
  IconLeft: {
    smooth: {
      color: TEXT_FOCUSED_COLOR[colorMode],
    },
  },
  IconRight: {
    smooth: {
      color: TEXT_FOCUSED_COLOR[colorMode],
    },
  },
  Label: {
    smooth: {
      color: TEXT_FOCUSED_COLOR[colorMode],
    },
  },
});

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const h = HEIGHT[screenSize];
  const font = getFont(FONT.OTTAWA_3, screenSize);

  return _merge(
    {
      h,
      Background: {
        h,
        color: FILL_UNFOCUSED_COLOR[colorMode],
        borderRadius: BORDER_RADIUS[screenSize],
      },
      IconLeft: {
        y: Math.round((h - ICON_HEIGHT[screenSize]) / 2),
      },
      IconRight: {
        mountX: 1,
        y: Math.round((h - ICON_HEIGHT[screenSize]) / 2),
      },
      Label: {
        mountX: 0.5,
        x: middle,
        y: Math.round((h - font.lineHeight) / 2),
        text: {
          ...font,
          maxLines: 1,
          verticalAlign: 'middle',
          textAlign: 'center',
        },
      },
    },
    getUnFocusedStyle(context),
  );
};
